module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "dialog-fade"
    },
    on: {
      "after-enter": _vm.afterEnter,
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "el-dialog__wrapper",
    on: {
      "mousedown": _vm.handleWrapperMousedown,
      "mouseup": _vm.handleWrapperMouseup
    }
  }, [_c('div', {
    key: _vm.key,
    ref: "dialog",
    class: [
      'el-dialog',
      {
        'is-fullscreen': _vm.fullscreen,
        'el-dialog--center': _vm.center
      },
      _vm.customClass
    ],
    style: (_vm.style),
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-label": _vm.title || 'dialog'
    }
  }, [_c('div', {
    staticClass: "el-dialog__header"
  }, [_vm._t("title", function() {
    return [_c('span', {
      staticClass: "el-dialog__title"
    }, [_vm._v(_vm._s(_vm.title))])]
  }), _vm._v(" "), (_vm.showClose) ? _c('button', {
    staticClass: "el-dialog__headerbtn",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('i', {
    staticClass: "el-dialog__close el-icon el-icon-close"
  })]) : _vm._e()], 2), _vm._v(" "), (_vm.rendered) ? _c('div', {
    staticClass: "el-dialog__body"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "el-dialog__footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06d8b01e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/element-ui/packages/dialog/src/component.vue
// module id = 2013
// module chunks = 228